import type { ReactNode } from 'react';

export class RegularAttribute {
  readonly value: string | ReactNode;
  readonly label: string;

  constructor(label: string, value: string | ReactNode) {
    this.label = label;
    this.value = value;
  }
}
